<template lang="pug">
  DataTablePage(
    mainColumn="name"
    longColumn="type"
    resource="/dock/manufacturer"
    title="厂商管理"
    label="厂商管理"
    labelName="name"
    :toolbar="toolbar"
    :operation="operation"
    :operationWidth="252"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :createList="createList"
    :updateList="updateList"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
// import SmartDialog from '@/components/SmartDialog'
import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
import { operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'
// import { fetchUpdate, fetchList } from '@/utils/api'

export default {
  name: 'Collector',
  components: {
    DataTablePage
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    const hasUpdate = checkActions('/system/account/update')
    const hasDelete = checkActions('/system/account/delete')
    return {
      toolbar: [{
        ...toolbarCreate,
        isShow () {
          return checkActions('/system/account/create')
        }
      }],
      operation: [{
        ...operationUpdate,
        isShow () {
          return hasUpdate
        }
      }, {
        ...operationDelete,
        isShow () {
          return hasDelete
        }
      }],
      tableInitList: ['name', 'createTime'],
      tableFullList: ['name', 'createTime'],
      filterInitList: ['name'],
      filterFullList: ['name'],
      createList: ['name'],
      updateList: ['name'],
      tableData: [],
      columns: {
        name: {
          label: '厂商名称',
          filter: {
            type: 'input',
            width: 120,
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入设备编号'
            }]
          }
        },
        createTime: {
          label: '创建时间',
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss',
          filter: {
            type: 'select',
            live: true
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Manufacturer.vue?7f3bde95